import { TicTacToe, Square } from "./components";
import './App.css';

function App() {
  return (
    <TicTacToe >
    </TicTacToe>
    
  );
}

export default App;
